import {
    API
} from '../Api.class';

export class CampaignStatsAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

    }


    async predictPerformance(body, meta) {
        this.loading = true

        return await this.__axiosInstance.post('api/v1/campaigns/stats/performance/predict', body, {
            meta,
        })
    }


}